import React from 'react';
import PropTypes from 'prop-types';
import { Form, Button } from 'semantic-ui-react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

const AuditSearch = ({
  onDateChangeHandler,
  onSearchHandler,
  clearDates,
  startDate,
  endDate,
}) => {
  return (
    <div>
      <Form>
        <Form.Group widths='equal'>
          <Form.Field required>
            <label htmlFor='startDate'>Start Date</label>
            <div>
              <DatePicker
                id='startDate'
                style={{ padding: '0', width: '100%' }}
                selected={startDate}
                onChange={date => onDateChangeHandler('startDate', date)}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          </Form.Field>
          <Form.Field>
            <label htmlFor='endDate'>End Date</label>
            <div>
              <DatePicker
                id='endDate'
                style={{ padding: '0', width: '100%' }}
                selected={endDate}
                onChange={date => onDateChangeHandler('endDate', date)}
                dateFormat='YYYY-MM-DD'
              />
            </div>
          </Form.Field>
          <Form.Field>
            <label htmlFor='searchButton' style={{ visibility: 'hidden' }}>Search Actions</label>
            <div id='actions'>
              <Button id='searchButton' color='green' onClick={onSearchHandler} inverted>
                Search
              </Button>
              <Button color='green' onClick={clearDates} inverted>
                Clear
              </Button>
            </div>
          </Form.Field>
        </Form.Group>
      </Form>
      <br />
      <br />
    </div>
  );
};

AuditSearch.propTypes = {
  onDateChangeHandler: PropTypes.func,
  onSearchHandler: PropTypes.func,
  clearDates: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
};

export default AuditSearch;
